
export default function markExternalLinks() {
    document.querySelectorAll('a[href]').forEach(link => {
        const url = new URL(link.href, window.location.origin);
        const isExternal = url.origin !== window.location.origin;

        if ((url.protocol === 'http:' || url.protocol === 'https:') && isExternal) {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer'); // Sicherheits- und Performance-Gründe
        }
    });
}